export default __webpack_public_path__ + "static/logo1-ce028a6bc6e61bb7ca7a89c285c93ddf.png";